const LoadingCard = () => (
  <div className="flex size-full w-full animate-pulse flex-col items-center justify-center">
    <div className="aspect-square w-screen max-w-full">
      <div
        data-test-id="IVwUj6uPgl7xb2a85acfY"
        className="relative flex size-full flex-col items-center justify-center rounded-2xl bg-slate-100 text-center"
      />
    </div>
    <div
      data-test-id="NmHuvq8uCrq5Igy9ohB3z"
      className="my-4 flex h-24 min-w-full flex-col items-start justify-center"
    >
      <div className="grid w-full grid-flow-col grid-rows-4 gap-4">
        <div className="grid grid-cols-5 gap-4">
          <div className="col-span-4 h-2 rounded bg-slate-200" />
          <div className="col-span-1 h-2 rounded bg-slate-200" />
        </div>
        <div className="h-2 rounded bg-slate-200" />
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-2 h-2 rounded bg-slate-200" />
          <div className="col-span-1 h-2 rounded bg-slate-200" />
        </div>
        <div className="h-2 rounded bg-slate-200" />
      </div>
    </div>
  </div>
);

export default LoadingCard;
